import http from '../../http';
import { CompanyTagResource } from '../entities';
import { JsonApiResponse } from '../interfaces';

const resource = 'company-tags';

/**
 * @description Retrieves all company tag records.
 * @param {Record<string, string>} filters
 * @param {Record<string, string>} page
 * @return {Promise<CompanyTagResource[]>}
 */
const getAll = async (
  filters?: Record<string, string>,
  page?: Record<string, string>,
): Promise<CompanyTagResource[]> => {
  const filtersString = filters
    ? `${Object.keys(filters)
        .map((key) => `filter[${key}]=${filters[key]}`)
        .join('&')}`
    : '';
  const pageString = page
    ? `${Object.keys(page)
        .map((key) => `page[${key}]=${page[key]}`)
        .join('&')}`
    : '';

  const response = await http.get<JsonApiResponse<CompanyTagResource[]>>(
    `/${resource}?${[filtersString, pageString].join('&')}`,
  );
  // cast(response.data.data)
  return response.data.data;
};

const CompanyTagsDataService = {
  getAll,
};

export default CompanyTagsDataService;
